// @ts-nocheck
import { LayoutColumnist } from './layouts/LayoutColumnist'
import { LayoutColumnistDesktop } from './layouts/LayoutColumnist'
import { LayoutColumnistSideBox } from './layouts/LayoutColumnistSideBox'
import { LayoutDefault } from './layouts/LayoutDefault'
import { LayoutEditais } from './layouts/LayoutEditais'
import { LayoutFeatured } from './layouts/LayoutFeatured'
import { LayoutFeaturedImage } from './layouts/LayoutFeaturedImage'
import { LayoutFeaturedNoImage } from './layouts/LayoutFeaturedNoImage'
import { LayoutFeaturedRelated } from './layouts/LayoutFeaturedRelated'
import { LayoutGrid3 } from './layouts/LayoutGrid3'
import { LayoutGrid4 } from './layouts/LayoutGrid4'
import { LayoutPodcast } from './layouts/LayoutPodcast'
import { LayoutRadio } from './layouts/LayoutRadio'
import { LayoutSearch } from './layouts/LayoutSearch'
import { LayoutStories } from './layouts/LayoutStories'
import { LayoutMostRead } from './layouts/LayoutMostRead'
import { LayoutVideoHome } from './layouts/LayoutVideoHome'
import { LayoutVideoLive } from './layouts/LayoutVideoLive'
import { LayoutVideoFeatured } from './layouts/LayoutVideoFeatured'

const slotLayouts = {
  LayoutColumnist,
  LayoutColumnistDesktop,
  LayoutColumnistSideBox,
  LayoutDefault,
  LayoutEditais,
  LayoutFeatured,
  LayoutFeaturedImage,
  LayoutFeaturedNoImage,
  LayoutFeaturedRelated,
  LayoutGrid3,
  LayoutGrid4,
  LayoutPodcast,
  LayoutRadio,
  LayoutSearch,
  LayoutStories,
  LayoutMostRead,
  LayoutVideoHome,
  LayoutVideoLive,
  LayoutVideoFeatured
}

export const slotLayoutsArray: string[] = Object.keys(slotLayouts)

export type teaserTypes = typeof slotLayoutsArray[number]

export { slotLayouts }
